import { darken, makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  infoContainer: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  loadingWrapper: {
    padding: theme.spacing(2),
  },
  skeleton: {
    height: 40,
    marginBottom: theme.spacing(1),
  },
  resultsDivider: {
    margin: theme.spacing(0.5, 1),
  },
  tableContainer: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    justifyContent: 'flex-end'
  },
  pagination: {
    marginTop: '10px'
  },
  noResults: {
    marginTop:50,
    textAlign:"center",
    width:"98%",
    "& .no-results-text":{
      border:"1px solid",
      borderColor:darken(theme.palette.amano.warnings.fire,.3),
      padding:"8px 92px 8px 92px",
      backgroundColor: theme.palette.background.paper,
      fontSize:"14pt",
      fontStyle:"italic",
      fontWeight:"bold",
      color:darken(theme.palette.amano.warnings.fire,.2),
      opacity:0.7,
      borderRadius:3,
      boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
    },
  },
}));
